export default "__VITE_ASSET__DMMzUsFc__"